// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__-qnpp","loader_spinner":"Loader_loader_spinner__D7q9B"};